import debounce from "lodash/debounce";
import { DecimalNumberInput } from "PFComponents/text/decimal_number_input";
import Toggle from "PFComponents/toggle/toggle";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { BookingDetailItem } from "../../booking_detail_item";
import css from "./requirement_option.module.scss";

interface RequirementOptionProps {
  label: string;
  onChange: (value: number | undefined) => void;
  max?: number;
  defaultValue: number | undefined;
  autofocus: boolean;
  useTimeVisible: boolean;
  withTime: boolean;
  onWithTimeChange: () => void;
}

export const RequirementOption = ({
  label,
  onChange,
  max,
  defaultValue,
  autofocus,
  useTimeVisible,
  withTime,
  onWithTimeChange
}: RequirementOptionProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "bookings" });

  const debouncedHandleChange = useRef(
    debounce((value: number | undefined) => {
      onChange(value);
    }, 1000)
  ).current;

  return (
    <BookingDetailItem
      label={label}
      value={
        <div className={css.root}>
          <DecimalNumberInput
            title={label}
            defaultValue={defaultValue}
            onChange={debouncedHandleChange}
            max={max}
            autofocus={autofocus}
          />
          {useTimeVisible && (
            <Toggle
              reversed
              compact
              checked={withTime}
              onChange={onWithTimeChange}
              description={t("useTime")}
            />
          )}
        </div>
      }
    />
  );
};
